import React, { Component } from "react";

class VideoCipherPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      watermarkTexts: [],
      watermarkStyleList: [],
    };
  }

  componentDidMount() {
    this.setupWatermarks();
    this.loadVdoPlayer();
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  }

  componentDidUpdate(prevProps) {
    // Update watermarks if props change
    if (
      prevProps.userdata?.ip !== this.props.userdata?.ip ||
      prevProps.AffiliateName !== this.props.AffiliateName ||
      prevProps.Mobile !== this.props.Mobile ||
      prevProps.emailid !== this.props.emailid
    ) {
      this.setupWatermarks();
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
  }

  setupWatermarks = () => {
    const { ipaddress, AffiliateName, Mobile, emailid } = this.props;

    const watermarkTexts = [
      ipaddress || "",
      AffiliateName || "",
      emailid || "",
      Mobile || "",
    ].filter(Boolean); // remove empty strings

    this.setState({ watermarkTexts }, () => {
      this.moveWatermarks();
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.moveWatermarks, 10000); // move every 10s
    });
  };

  moveWatermarks = () => {
    const watermarkStyleList = this.state.watermarkTexts.map(() => ({
      top: `${10 + Math.random() * 70}%`,
      left: `${10 + Math.random() * 70}%`,
    }));
    this.setState({ watermarkStyleList });
  };

  loadVdoPlayer = () => {
    if (!window.VdoPlayer) {
      const playerScript = document.createElement("script");
      playerScript.src = "https://player.vdocipher.com/playerAssets/1.6.10/vdo.js";
      playerScript.onload = this.initializePlayer;
      document.body.appendChild(playerScript);
    } else {
      this.initializePlayer();
    }
  };

  initializePlayer = () => {
    const { otp, playbackInfo } = this.props;
    if (!otp || !playbackInfo) return;

    this.playerInstance = new window.VdoPlayer({
      otp,
      playbackInfo,
      theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
      container: document.getElementById("cipher-player"),
    });
  };

  handleFullscreenChange = () => {
    const watermarks = document.querySelectorAll(".watermark");
    const player = document.getElementById("cipher-player");
    if (document.fullscreenElement) {
      watermarks.forEach((w) => document.fullscreenElement.appendChild(w));
    } else {
      watermarks.forEach((w) => player.parentNode.appendChild(w));
    }
  };

  render() {
    const { watermarkTexts, watermarkStyleList } = this.state;

    return (
      <div style={{ position: "relative", width: "100%", height: "fit-content" }}>
        <div id="cipher-player" style={{ width: "100%", height: "400px" }}></div>
        {watermarkTexts.map((text, index) => (
          <div
            key={index}
            className="watermark"
            style={{
              position: "absolute",
              top: watermarkStyleList[index]?.top || "50%",
              left: watermarkStyleList[index]?.left || "50%",
              color: "red",
              fontSize: "13px",
              pointerEvents: "none",
              userSelect: "none",
              zIndex: 9999, // lower so it doesn’t block controls
              fontFamily: "sans-serif"
            }}

    
          >
            {text}
          </div>
        ))}
      </div>
    );
  }
}

export default VideoCipherPlayer;
